// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";
import { getFeedbackSuccess, getFeedbackFailure } from "./actions";
import { GET_FEEDBACK_REQUEST } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
function* getFeedback(action) {
  try {
    

    let url = `/jobseeker/fetch_candidates_feedback?page=${action.payload.page}&per_page=${action.payload.per_page}`;
    if (action.payload.column) {
      url += `&sortBy=${action.payload.column}`;
    }
  
    if (action.payload.direction) {
      url += `&direction=${action.payload.direction}`;
    }
    const response = yield call(() =>
      AxiosInstance().post(url, action.payload.data)
    );
    yield put(getFeedbackSuccess(response.data));
  } catch (error) {
    yield put(getFeedbackFailure(error));
  }
}

function* getFeedbackSaga() {
  yield takeLatest(GET_FEEDBACK_REQUEST, getFeedback);
}

export default getFeedbackSaga;
